import CircularProgress from './circular-proogress';

export default CircularProgress;
